import React, { FC } from "react";
import clsx from "clsx";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Theme } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import InfoIcon from "../../../../../components/InfoIcon";

const useStyles = makeStyles((theme: Theme) => ({
  label: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#535358",
  },
  asterisk: {
    color: "#535358",
    lineHeight: "inherit",
    fontSize: 16,
    fontWeight: "normal",
    marginLeft: 3,
  },
  hasError: {
    color: theme.palette.error.main,
  },
}));

interface ILabelProps {
  label: string;
  isRequired?: boolean;
  hasError?: boolean;
  infoText?: string;
  className?: string;
}

const FieldsGroupLabel: FC<ILabelProps> = ({
  label,
  isRequired = false,
  hasError = false,
  infoText = "",
  className,
}) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.label, className)}>
      {label}
      {isRequired && (
        <Typography
          className={clsx(classes.asterisk, hasError && classes.hasError)}
          component={"span"}
          variant={"subtitle2"}
        >
          *
        </Typography>
      )}
      {infoText && <InfoIcon text={infoText} portalMode={false} />}
    </div>
  );
};

export default React.memo(FieldsGroupLabel);
